import { DeviceParametersActions, DeviceActionTypes } from './device-parameters.actions';
import { DeviceParametersStateInterface } from './device-parameters.model';

export const DeviceParametersInitialState: DeviceParametersStateInterface = {
  errors: [],
  getDeviceParametersLoading: false,
  getDeviceParametersLoaded: false,
  deviceParameters: [{ deviceTypeId: null, parameters: [], preparedVerbs: [] }],
};

export function deviceParametersReducer(
  state = DeviceParametersInitialState,
  action: DeviceParametersActions,
): DeviceParametersStateInterface {
  switch (action.type) {
    case DeviceActionTypes.GetDeviceParameters:
      return {
        ...state,
        getDeviceParametersLoading: true,
        getDeviceParametersLoaded: false,
      };
    case DeviceActionTypes.GetDeviceParametersCompleted:
      return {
        ...state,
        getDeviceParametersLoading: false,
        getDeviceParametersLoaded: true,
        deviceParameters: action.payload.data,
      };

    case DeviceActionTypes.ClearState:
      return { ...DeviceParametersInitialState };

    case DeviceActionTypes.FetchError:
      return {
        ...state,
        errors: action.payload,
      };

    default:
      return state;
  }
}
